import { z } from 'zod';

import { BillingFormFieldTypes } from '@features/campaigns/details/components/FormFields/FieldTypes.ts';

export const billingDetailsValidationSchema = z.object({
  [BillingFormFieldTypes.AGENCY]: z
    .string({
      required_error: 'errorMessages.required',
    })
    .optional(),
  [BillingFormFieldTypes.BILLING_CONTACT]: z
    .string({
      required_error: 'errorMessages.required',
    })
    .nonempty({
      message: 'errorMessages.required',
    }),
  [BillingFormFieldTypes.PURCHASE_ORDER]: z
    .string({
      required_error: 'errorMessages.required',
    })
    .optional(),
  [BillingFormFieldTypes.AUTHORIZED_BUDGET]: z
    .union([
      z
        .number({
          required_error: 'errorMessages.required',
          invalid_type_error: 'errorMessages.numericalValueRequired',
        })
        .min(1, 'errorMessages.minAuthorizedBudget')
        .max(5000000, 'errorMessages.maxAuthorizedBudget'),
      z.null(),
    ])
    .transform((value, ctx) => {
      if (value === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'errorMessages.numericalValueRequired',
        });
      }
      return value;
    })
    .optional(),
  [BillingFormFieldTypes.REAL_BUDGET]: z
    .union([
      z
        .number({
          required_error: 'errorMessages.required',
          invalid_type_error: 'errorMessages.numericalValueRequired',
        })
        .min(1, 'errorMessages.minRealBudget')
        .max(5000000, 'errorMessages.maxRealBudget'),
      z.null(),
    ])
    .optional(),
});

export type BillingDetailsValues = z.infer<typeof billingDetailsValidationSchema>;
